import { computed } from 'vue';

import useSortFilter from './useSortFilter';
import useFacets from './useFacets';

export default function useSortByCriteria() {
  const {
    triggerSelectedFacetsUpdate,
    updateSortbySelected,
    isSlideoutMode,
    sortByOptions,
    sortBy,
  } = useFacets();

  const { updateSortBy, selections } = useSortFilter();

  const dropdownUpdate = (selected) => {
    if (isSlideoutMode.value) {
      updateSortBy(selected);
    } else {
      updateSortbySelected(selected);
      triggerSelectedFacetsUpdate();
    }
  };

  const dropdownValue = computed(() => (
    isSlideoutMode.value
      ? selections.value.sortBySelectedValue
      : sortBy.value.selectedValue
  ));

  return {
    dropdownValue,
    dropdownUpdate,
    sortByOptions,
  };
}
